import i18n from 'modules/core/lib/i18n'

import { NpsVisibilityConfig, NpsWidgetVariant } from './types'

type ProductFamilies = 'talent' | 'finance' | 'time' | 'core'
const VARIANTS: Record<ProductFamilies, NpsWidgetVariant> = {
  talent: 'radical',
  core: 'tangerine',
  finance: 'viridian',
  time: 'champagne',
}

export const getNpsVisibility: NpsVisibilityConfig = (navigation) => ({
  factorial: {
    icon: 'logo-avatar',
    variant: 'radical',
    routes: [
      navigation.dashboard.fullPath(),
      navigation.discover.productUpdates.fullPath(),
      navigation.discover.marketplaceModules.fullPath(),
      navigation.discover.marketplace.fullPath(),
      navigation.inbox.fullPath(),
      navigation.profile.fullPath(),
    ],
    productName: i18n.t('common.company_name'),
  },
  ats: {
    icon: 'user-search',
    variant: VARIANTS.talent,
    routes: [navigation.ats.fullPath()],
    productName: i18n.t('sidebar.recruitment'),
  },
  documents: {
    icon: 'documents',
    variant: VARIANTS.core,
    routes: [navigation.documents.fullPath(), navigation.files.fullPath()],
    productName: i18n.t('sidebar.documents'),
  },
  analytics: {
    icon: 'analytics-graph',
    variant: VARIANTS.core,
    routes: [navigation.analytics.fullPath()],
    productName: i18n.t('sidebar.analytics'),
  },
  time_tracking: {
    icon: 'time-tracking',
    variant: VARIANTS.time,
    routes: [navigation.timeTracking.fullPath()],
    productName: i18n.t('sidebar.time_tracking'),
  },
  timeoff: {
    icon: 'time-off',
    variant: VARIANTS.time,
    routes: [navigation.timeOff.fullPath(), navigation.calendar.fullPath()],
    productName: i18n.t('sidebar.time_off'),
  },
  shift_management: {
    icon: 'time-planning',
    variant: VARIANTS.time,
    routes: [navigation.shifts.fullPath()],
    productName: i18n.t('sidebar.shift_management'),
  },
  payroll: {
    icon: 'payroll-process',
    variant: VARIANTS.core,
    routes: [navigation.payrollBundle.fullPath(), navigation.myPayroll.fullPath()],
    productName: i18n.t('sidebar.payroll_bundle'),
  },
  projects: {
    icon: 'suitcase',
    variant: VARIANTS.finance,
    routes: [navigation.projects.fullPath(), navigation.myProjects.fullPath()],
    productName: i18n.t('sidebar.projects_management'),
  },
  procurement: {
    icon: 'money-bag',
    variant: VARIANTS.finance,
    routes: [navigation.finance.spending.procurement.fullPath(), navigation.myPurchases.fullPath()],
    productName: i18n.t('finance.modules.spending.procurement'),
  },
  expenses: {
    icon: 'money-bag',
    variant: VARIANTS.finance,
    routes: [navigation.finance.spending.expenses.fullPath(), navigation.myExpenses.fullPath()],
    productName: i18n.t('sidebar.expenses_v2'),
  },
  trainings: {
    icon: 'window-user',
    variant: VARIANTS.talent,
    routes: [navigation.trainings.fullPath(), navigation.myTrainings.fullPath()],
    productName: i18n.t('sidebar.trainings'),
  },
  reviews: {
    icon: 'performance',
    variant: VARIANTS.talent,
    routes: [navigation.performanceProcess.fullPath()],
    productName: i18n.t('sidebar.performance_new'),
  },
  software_management: {
    icon: 'floppy-disk',
    variant: VARIANTS.finance,
    routes: [navigation.software.fullPath()],
    productName: i18n.t('sidebar.software_management'),
  },
  finance: {
    icon: 'money-bag',
    variant: VARIANTS.finance,
    routes: [
      navigation.finance.spending.invoices.fullPath(),
      navigation.finance.financialWorkspace.fullPath(),
      navigation.finance.accounting.fullPath(),
    ],
    productName: i18n.t('sidebar.finance'),
  },
  benefits: {
    icon: 'gift',
    variant: VARIANTS.finance,
    routes: [navigation.benefits.fullPath(), navigation.myBenefits.fullPath()],
    productName: i18n.t('benefits.module_name'),
  },
})
